import { createAPIUrl } from '../frontend/utils/createUrl';
import { handlePossibleAuthError } from '../frontend/utils/requestErrorHandler';

const methods = [
    ['get', 'GET'],
    ['post', 'POST'],
    ['put', 'PUT'],
    ['patch', 'PATCH'],
    ['del', 'DELETE'],
];

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
class _ApiClient {
    constructor(opts) {
        if (__SERVER__ && !opts) {
            throw new Error('_ApiClient opts must be included');
        }

        methods.forEach(([method, verb]) => {
            this[method] = (path, { params, data, fileUpload } = {}) => {
                const apiUrl = createAPIUrl(path);
                const url = new URL(apiUrl);
                if (params) {
                    Object.keys(params).forEach((key) =>
                        url.searchParams.append(key, params[key])
                    );
                }
                const headers = {
                    Accept: 'application/json',
                };
                if (__CLIENT__) {
                    headers['x-csrf-token'] = global.__csrfToken;
                }
                if (__SERVER__ && opts.userToken) {
                    headers.Authorization = `Bearer ${opts.userToken}`;
                    headers.Cookie = opts.userToken;
                }
                if (fileUpload) {
                    data = new FormData();
                    data.append('files', fileUpload.file, fileUpload.name);

                    Object.keys(fileUpload.fields || {}).forEach((field) => {
                        data.append(field, fileUpload.fields[field]);
                    });
                } else if (data) {
                    data = JSON.stringify(data);
                    headers['Content-Type'] = 'application/json';
                }
                return fetch(url, {
                    method: verb,
                    credentials: 'include',
                    headers,
                    body: data,
                }).then((res) => {
                    if (res.ok) {
                        return res.status === 204 ? null : res.json();
                    } else {
                        if (__CLIENT__) {
                            handlePossibleAuthError(null, res);
                        }
                        return Promise.reject(res);
                    }
                });
            };
        });
    }
}

const ApiClient = _ApiClient;

export default ApiClient;
